import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CarrouselFacultadesSimpleComponent } from '../../widgets/carrousel-facultades-simple/carrousel-facultades-simple.component';

@Component({
  selector: 'app-galeria-imagenes-videos',
  standalone: true,
  imports: [CommonModule, CarrouselFacultadesSimpleComponent],
  templateUrl: './galeria-imagenes-videos.component.html',
  styleUrl: './galeria-imagenes-videos.component.scss'
})
export class GaleriaImagenesVideosComponent {
  @Input() info: any;
}
